import React, { useState, useEffect } from 'react';
import { VStack, Divider } from 'native-base';
import { Dimensions, StyleSheet } from 'react-native';
import MenuHeader from './MenuHeader';
import MenuChannelsHeader from './MenuChannelsHeader';
import Channels from './Channels';
import MenuLinks from './MenuLinks';
const calculateHeight = screenHeight => screenHeight * 0.8;
const getPaddingBottom = screenHeight => {
  if (screenHeight >= 600) {
    return 50;
  } else if (screenHeight >= 400) {
    return 80;
  }
  return 120;
};
const getStyles = screenHeight => {
  const paddingBottom = getPaddingBottom(screenHeight);
  return StyleSheet.create({
    menuChannelsHeader: {
      width: '100%',
      height: calculateHeight(screenHeight),
      overflow: 'scroll',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: paddingBottom
    }
  });
};
const MenuSide = props => {
  const [screenHeight, setScreenHeight] = useState(Dimensions.get('window').height);
  const [styles, setStyles] = useState(getStyles(screenHeight));
  useEffect(() => {
    const updateDimensions = () => {
      const newHeight = Dimensions.get('window').height;
      setScreenHeight(newHeight);
      setStyles(getStyles(newHeight));
    };
    const dimensionChangeListener = Dimensions.addEventListener('change', updateDimensions);
    return () => {
      dimensionChangeListener.remove();
    };
  }, []);
  return /*#__PURE__*/React.createElement(VStack, {
    display: props.display,
    alignItems: 'center',
    style: {
      marginLeft: '20px',
      top: '70px',
      position: 'sticky'
    }
  }, /*#__PURE__*/React.createElement(MenuHeader, {
    navigation: props.navigation,
    startNewTopicButtonRef: props.startNewTopicButtonRef
  }), /*#__PURE__*/React.createElement(VStack, {
    style: styles.menuChannelsHeader
  }, /*#__PURE__*/React.createElement(MenuChannelsHeader, null), /*#__PURE__*/React.createElement(Channels, {
    orientation: 'vertical',
    setPage: props.setPage,
    setHasMoreTopics: props.setHasMoreTopics
  }), /*#__PURE__*/React.createElement(Divider, {
    mt: 5,
    mb: 5
  }), /*#__PURE__*/React.createElement(MenuLinks, {
    isGuidelineModalOpen: props.isGuidelineModalOpen,
    setIsGuidelineModalOpen: props.setIsGuidelineModalOpen
  })));
};
export default MenuSide;
//# sourceMappingURL=MenuSide.js.map